import { render, staticRenderFns } from "./sales-direct-list.vue?vue&type=template&id=9aa272ec&"
import script from "./sales-direct-list.vue?vue&type=script&lang=js&"
export * from "./sales-direct-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports